const STATUS_MAP = {
  "New from Gmail":         { bg: "#E0F2FE", fg: "#0369A1", dot: "#0EA5E9" },
  "Pending CAD Input":      { bg: "#FEF3C7", fg: "#92400E", dot: "#F59E0B" },
  "Pending Production Input": { bg: "#FFEDD5", fg: "#9A3412", dot: "#F97316" },
  "Ready for Review":       { bg: "#FEF08A", fg: "#713F12", dot: "#CA8A04" },
  "Approved":               { bg: "#DCFCE7", fg: "#166534", dot: "#22C55E" },
  "Rejected":               { bg: "#FEE2E2", fg: "#991B1B", dot: "#EF4444" },
  "Draft":                  { bg: "#F1F5F9", fg: "#334155", dot: "#94A3B8" },
  "Under Preparation":      { bg: "#FEF3C7", fg: "#92400E", dot: "#F59E0B" },
  "Ready for Approval":     { bg: "#FEF08A", fg: "#713F12", dot: "#CA8A04" },
  "Released":               { bg: "#DBEAFE", fg: "#1D4ED8", dot: "#3B82F6" },
};

export default function StatusChip({ status, size = "md" }) {
  const c = STATUS_MAP[status] || { bg: "#F1F5F9", fg: "#334155", dot: "#94A3B8" };
  const isSm = size === "sm";
  return (
    <span
      data-testid={`status-chip-${status?.toLowerCase().replace(/\s+/g, "-")}`}
      className={`inline-flex items-center gap-1.5 rounded-full font-medium ${isSm ? "px-2 py-0.5 text-[11px]" : "px-2.5 py-0.5 text-xs"}`}
      style={{ backgroundColor: c.bg, color: c.fg }}
    >
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: c.dot }} />
      {status}
    </span>
  );
}
